module.exports = __webpack_public_path__ + "img/next.6332fe74.svg";